var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1659 4.98353C10.9812 3.67219 13.0195 3.67212 13.8348 4.98353L20.7137 16.0499C21.529 17.3615 20.5093 19.0011 18.8788 19.0011H5.12095C3.49052 19.0009 2.47172 17.3614 3.28697 16.0499L10.1659 4.98353ZM11.9999 15.5812C11.4343 15.5814 10.9999 15.9983 10.9999 16.5411C10.9999 17.0839 11.4343 17.5009 11.9999 17.5011C12.5656 17.5011 12.9998 17.084 12.9999 16.5411C12.9999 15.9982 12.5656 15.5812 11.9999 15.5812ZM11.9999 7.50013C11.4475 7.50025 11.0658 7.7152 11.079 8.27064L11.2899 14.0411C11.3032 14.5584 11.6448 14.7353 11.9999 14.7355C12.3551 14.7355 12.6975 14.5586 12.7108 14.0411L12.9217 8.27064C12.9349 7.71506 12.5525 7.50013 11.9999 7.50013Z",
    fill: "#EA5032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIco);
export default __webpack_public_path__ + "static/media/Notice_ico.b6f65cf1480ff90d18cf136de52c8a11.svg";
export { ForwardRef as ReactComponent };